require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-oberpullendorf-grosswarasdorf.json") })
        }
      }, "path---betreuungseinrichtungen-oberpullendorf-grosswarasdorf");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-oberpullendorf-grosswarasdorf!./.cache/json/betreuungseinrichtungen-oberpullendorf-grosswarasdorf.json
// module id = 974
// module chunks = 231608221292675